import axios from 'axios';
import {BASE_API_URL, PREFIX_API_PUBLIC} from '@/constants';

const entityName = 'application';

export default class ApplicationService {

  /**
   * Retrieve min file size allowed
   */
  public getMinFileSize(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${BASE_API_URL}${PREFIX_API_PUBLIC}${entityName}/file-min-size`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * Retrieve max file size allowed
   */
  public getMaxFileSize(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${BASE_API_URL}${PREFIX_API_PUBLIC}${entityName}/file-max-size`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}
